export default [  
  {
    path: '/contacts',
    name: 'contacts',
    component: () => import('@/views/modules/contacts/list'),
    meta: {
      requiresAuth: true,
      layout: 'app',
      title:'Contacts List',
      breadcrumb: [
        { text: 'Home',  to: { name: "home" } },
        { text: 'Contacts' }
      ]
    },
    children:[
      {
        path: '/contacts/create',
        name: 'contacts-create',
        component: () => import('@/views/modules/contacts/create'),
        meta: {
          sidebarToggle: true,
          requiresAuth: true,
          layout: 'app',
          title:'Contact Create',
          breadcrumb: [
            { text: 'Home',  to: { name: "home" } },
            { text: 'Contacts', link: '/contacts' },
            { text: 'Create' }
          ]
        }
      },
     
      
    
    ]
  },

  {
    path: '/contacts/:id/show',
    props: true,
    name: 'contacts-show',
    component: () => import('@/views/modules/contacts/show'),
    meta: {
      requiresAuth: true,
      layout: 'app',
      title:'Contacts Details',
      breadcrumb: [
        { text: 'Home',  to: { name: "home" } },
        { text: 'Contacts',  to: { name: "contacts" } },
        { text: 'Details' }
      ]
    },
    children:[
      {
        path: '/contacts/:id/edit',
        props: true,
        name: 'contacts-edit',
        component: () => import('@/views/modules/contacts/edit'),
        meta: {
          sidebarToggle: true,
          requiresAuth: true,
          layout: 'app',
          title:'Contacts Edit',
          breadcrumb: [
            { text: 'Home',  to: { name: "home" } },
            { text: 'Contact',  to: { name: "contacts-show" }, param: 'id' },
            { text: 'Edit' }
          ]
        }
      },
    ]
  },
 
]